module.exports = __webpack_public_path__ + "img/logo.c9683b8e.png";